export default ['Index', 'SendOrder', 'SearchOrder', 'CheckCarIndex', 'Tbox', 'BindGps', 'ThirdSign', 'NewAudit']



// WEBPACK FOOTER //
// ./src/api/whiteList.js